import styled from 'styled-components'

export const Error = styled.div`
  color: #e11900;
  margin-top: 8px;
  line-height: 16px;
`
export const CheckedIcon = styled.div`
  height: 16px;
  width: 16px;
  display: grid;
  place-items: center;
  border-radius: 2px;
  background: ${(p) => {
    return p.disabled ? 'rgba(32, 32, 32, 0.5)' : '#0AA1F4'
  }};
`

export const CheckBoxWrapper = styled.div`
  display: grid;
  place-items: center;
  height: 24px;
  width: 24px;
  user-select: none;
  cursor: pointer;
  margin-right: 8px;
  pointer-events: ${(p) => {
    return p.disabled ? 'none' : ''
  }};
`

export const CheckBoxContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${(p) => {
    return p.disabled ? 'rgba(32,32,32,0.5)' : ''
  }};
`
